import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { Observable, take, from, of, mergeMap } from 'rxjs';
import { PermissionService } from '@tablesready/frontend-permissions';

@Injectable({ providedIn: 'root' })
export class CanActivateRoute  {
  constructor(
    private readonly permissionService: PermissionService,
    private readonly router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const { scopes, availableFor } = route.data;

    return this.permissionService.userAccountHasScopesAsync(scopes, availableFor)
      .pipe(
        take(1),
        mergeMap((hasScopes) => {
          if (hasScopes) {
            return of(true);
          }

          return from(this.router.navigateByUrl('/profile/details'));
        }),
      );
  }
}
